/* eslint-disable no-unused-vars */

import React, { useMemo, useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import { HomePage } from "../../../styles/common.style";
import { useNavigate } from "react-router-dom";
import CustomVideoPlayer from "../AssessmentTimer/CustomVideoPlayer";
import { GetTestimonials } from "../../../actions/user_program";
import { setAlert } from "../../../actions/alert";
import { Button } from "react-bootstrap";
import { createTour } from "../../Layout/ShepherdTour";
import { PRELAUNCH } from "../../../utils/constants";

const Home1 = () => {
  const [typeFirstTestimonials, setFirstTestimonials] = useState([]);
  const [typeSecondTestimonials, setSecondTestimonials] = useState([]);
  const videoRefs = useRef([]);
  const videoRefAssessment = useRef(null);
  let navigate = useNavigate();

  const userData = localStorage.getItem("user");

  useEffect(() => {
    window.scrollTo(0, 0);
    getTestimonials();

    // Play the videos when the component is mounted
    videoRefs.current.forEach((video) => {
      if (video) {
        video.muted = true; // Ensure videos are muted for autoplay
        video.play().catch((error) => {
          console.error("Video autoplay failed:", error);
        });
      }
    });

    const video = videoRefAssessment.current;
    if (video) {
      video.muted = true; // Ensure videos are muted for autoplay
      video.play().catch((error) => {
        console.error("Video autoplay failed:", error);
      });
    }
  }, []);

  useEffect(() => {
    // TODO: Remove this line
    const isFirstLogin = localStorage.getItem("isFirstLogin") === "true";
    const tourShown = localStorage.getItem("tourShown") === "true";
    if (isFirstLogin && !tourShown) {
      const tour = createTour();
      tour.start();
      localStorage.setItem("tourShown", "true");
      localStorage.setItem("isFirstLogin", "false");
    }
  }, []);

  const getTestimonials = async () => {
    await GetTestimonials()
      .then((result) => {
        if (result.status) {
          if (result.data) {
            const allTestimonials = result.data;

            const type10Testimonials = allTestimonials.filter(
              (item) => item.type === 10
            );
            setFirstTestimonials(type10Testimonials);
            const type20Testimonials = allTestimonials.filter(
              (item) => item.type === 20
            );
            setSecondTestimonials(type20Testimonials);
          }
        } else {
          return setAlert(result.message, "danger");
        }
      })
      .catch((error) => {
        setAlert(error.response.data.message.replace(/_/g, " "), "danger");
      });
  };

  const handleAssessmentRedirect = () => {
    navigate("/welcome-to-assessment");
  };

  const handleAfterChange = (currentSlide) => {
    // Pause all videos except the current one
    videoRefs.current.forEach((video, index) => {
      if (video) {
        if (index === currentSlide) {
          video.play().catch((error) => {
            console.error("Video autoplay failed:", error);
          });
        } else {
          video.pause();
        }
      }
    });
  };

  const videos = [
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/1.+831.2.+Hamstring+Curl+Machine+Two+Legs+Top+View+Version2+COM.mp4",
      duration: 680,
    },
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/2.+706.+Cable+Machine+Runner%E2%80%99s+Knee+Drive+COM.mp4",
      duration: 710,
    },
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/3.+607.+Gastroc+Release+Kneeling+The+Stick+COM.mp4",
      duration: 740,
    },
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/4.++611.1.+Butt+Buster+(Hip+Extension)+On+Forearms+With+Band+COM.mp4",
      duration: 770,
    },
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/5.++608.+Glute+Bridge+Step+Heavy+Db2+COM.mp4",
      duration: 800,
    },
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/6.++618.+Nordic+Hamstring+Curl+Roll+Out+With+Ball2+COM.mp4",
      duration: 830,
    },
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/7.+++703.+Copenhagen+(Foot+On+Bench)+Lift+And+Lower3+COM.mp4",
      duration: 860,
    },
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/8.+++162.+Quad+Release+Foam+Roller+COM.mp4",
      duration: 890,
    },
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/9.++615.+Curtey+Lunge+Slider+Dumbbell+Straight+Leg+COM.mp4",
      duration: 920,
    },
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/10.++699.+Bulgarian+Split+Squat+Smith+Machine+(Glute+Focused)+COM.mp4",
      duration: 950,
    },
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/11.+830.+Glute+Max+Release+Floor%C2%A0With%C2%A0Ball+(2)+COM.mp4",
      duration: 980,
    },
    {
      src: "https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Home+Skeleton+Videos/12.++580.+Hex+Bar+Deadlift3+COM.mp4",
      duration: 1010,
    },
  ];

  const settingsVideo = useMemo(
    () => ({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            centerPadding: "30px",
            slidesToShow: 1,
          },
        },
      ],
    }),
    []
  );

  const settingsAbout = useMemo(
    () => ({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
    }),
    []
  );

  const settingsTestimonial = useMemo(
    () => ({
      dots: true,
      infinite: typeSecondTestimonials.length > 1, // Disable infinite scrolling if only one record
      speed: 500,
      arrows: false,
      autoplay: typeSecondTestimonials.length > 1, // Disable autoplay if only one record
      autoplaySpeed: 3000,
      slidesToShow: Math.min(typeSecondTestimonials.length, 4), // Show only the available number of slides
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: Math.min(typeSecondTestimonials.length, 3),
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: Math.min(typeSecondTestimonials.length, 2),
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            centerMode: typeSecondTestimonials.length > 1, // Enable center mode only if more than one record
            centerPadding: "30px",
            slidesToShow: 1,
          },
        },
      ],
    }),
    [typeSecondTestimonials]
  );

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    afterChange: handleAfterChange, // Add this to handle slide changes
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "30px",
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <HomePage>
      <section className="home_001 banner-section-block">
        <div className="banner-section-block-inner">
          <div className="common-container">
            <div
              className="setting-block-inner"
              data-aos="fade-right"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
            >
              {/* <Slider {...settings}> */}
              <div>
                <div className="setting-block-title">
                  <h3>
                    Is <span>Pain</span>
                    <br></br> Holding<br></br> You Back?
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="second-block">
        <div className="common-container">
          <div className="second-block-inner">
            <div className="second-block-inner-block">
              <h2
                data-aos="fade-zoom-in"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="800"
              >
                We offer <span className="span-block">PERSONALIZED</span>
                <br></br>
                corrective-exercise programs
                <br></br>
                based on your <span className="pr-2">ASSESSMENT</span>results
              </h2>
            </div>
            {!PRELAUNCH && (
              <div className="second-block-inner-btn">
                <button
                  onClick={handleAssessmentRedirect}
                  className="common-btn take-our-assessment"
                >
                  Take our assessment
                </button>
              </div>
            )}
            <div className="second-block-inner-block-right">
              <div
                className="second-block-inner-block-right-inner"
                data-aos="fade-zoom-in"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
              >
                <h3>
                  Tired of <span>Hurting ?</span>
                  <br></br> Keep Getting <span>Injured ?</span>
                  <br></br>
                </h3>
                <h3>
                  Muscle Imbalances <br></br>may be to blame
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="one-size-block">
        <div className="common-container">
          <div
            className="common-title-block"
            data-aos="fade-zoom-in"
            data-aos-offset="200"
            data-aos-easing="ease-in-sine"
            data-aos-duration="600"
          >
            <h3>
              These are NOT one-size-fits-all <span>programs!</span>
            </h3>
          </div>
        </div>
        <div className="img-chance-bloc">
          <img src="/images/chanse-img.png" alt="img" />
        </div>
        <div
          className="common-title-block mb-none-discription"
          data-aos="fade-zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="600"
        >
          <p>
            Each program is tailored to your <span>BODY TYPE</span> which will
            be determined from your<span> Assessment Results</span>.
          </p>
        </div>
      </section>
      <section className="video-block video-duration-hide">
        <div className="common-container">
          <div
            className="video-slider"
            data-aos="fade-up"
            data-aos-offset="200"
            data-aos-easing="ease-in-sine"
            data-aos-duration="600"
          >
            <Slider {...settingsVideo}>
              <div>
                <div className="video-slider">
                  <CustomVideoPlayer
                    videoUrl="https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Tired+Of+Hurting+(NEW)+COM.mp4"
                    className={"video"}
                    disableLazy={true}
                  />
                </div>
              </div>
              <div>
                <div className="video-slider">
                  <CustomVideoPlayer
                    videoUrl="https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Body+Types+Explained+New+(NEW)+COM.mp4"
                    className={"video"}
                  />
                </div>
              </div>
              <div>
                <div className="video-slider">
                  <CustomVideoPlayer
                    videoUrl="https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/2.+Body+Types+Explained+(NEW)+COM.mp4"
                    className={"video"}
                  />
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </section>
      <section className="about-section">
        <div className="common-container">
          <div className="about-section-inner">
            <div className="about-section-left">
              <div className="common-title-block">
                <h3
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                >
                  <span>About Us</span>
                </h3>
                <p
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="630"
                >
                  Helping people get out of pain is what we do!{" "}
                </p>
                <p
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="660"
                >
                  We specialize in identifying and correcting muscle imbalances
                  that cause pain.{" "}
                </p>
                <Button
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="660"
                  onClick={() => navigate("/pages/about-us")}
                  className="common-btn"
                >
                  Learn More
                </Button>{" "}
              </div>
              <div className="common-title-block">
                <h3
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="690"
                >
                  <span>Assessment</span>
                </h3>
                <p
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="720"
                >
                  A thorough assessment is essential to determine if muscle
                  imbalances might be the cause of your pain and dysfunction.
                </p>
                <p
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="750"
                >
                  Our ASSESSMENT utilizes artificial intelligence to identify
                  muscles in your body that may not be working as they should.
                </p>
                <Button
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="660"
                  onClick={() => navigate("/assessment-details")}
                  className="common-btn"
                >
                  Learn More
                </Button>{" "}
              </div>
            </div>
            <div className="about-section-right">
              <div
                className="slider-section-about"
                data-aos="fade-up"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
              >
                <div>
                  <div className="video-slider">
                    <video
                      playsInline
                      playinline
                      autoPlay
                      muted
                      loop
                      preload="auto"
                      ref={videoRefAssessment}
                      className="video"
                      width="100%"
                      height="100%"
                    >
                      <source
                        src="https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/New/Single+Leg+Squat+Right+Leg+3+In+1+4K+COM.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {!PRELAUNCH && (
        <section className="determine-block">
          <div className="determine-block-img">
            <img src="/images/determine-img.png" alt="img" />
          </div>
          <div className="common-container">
            <div
              className="determine-block-text"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
            >
              <h3>
                Take our ASSESSMENT to determine<br></br> which program is best
                for you
              </h3>
              <button className="common-btn" onClick={handleAssessmentRedirect}>
                Take Our Assessment
              </button>
            </div>
          </div>
        </section>
      )}
      <section className="step-block">
        <div className="common-container">
          <div className="common-title-block">
            <h3
              data-aos="fade-zoom-in"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
            >
              How It <span>Works</span> - 3 Steps
            </h3>
          </div>
        </div>
        <div className="common-container step-block-container">
          <div className="step-block-inner">
            <div
              className="step-block-inner-first common-step-block"
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
            >
              <div className="round-block">
                <h4>RECORD</h4>
              </div>
              <ol>
                <li>
                  Record yourself and answer questions as you are guided through
                  a series of movements.{" "}
                </li>
              </ol>
            </div>
            <div
              className="step-block-inner-second common-step-block"
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
            >
              <div className="round-block">
                <h4>ANALYZE</h4>
              </div>
              <ol>
                <li></li>
                <li>
                  Your dominant and under-active muscles will be determined.{" "}
                </li>
              </ol>
            </div>
            <div
              className="step-block-inner-third common-step-block"
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
            >
              <div className="round-block">
                <h4>RESULTS</h4>
              </div>
              <ol>
                <li></li>
                <li></li>
                <li>
                  Receive a BODY TYPE and a 12-week corrective-exercise program.{" "}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="receive-block">
        <div className="common-container">
          <div className="receive-block-inner">
            <div className="receive-block-inner-left">
              <h3
                data-aos="fade-zoom-in"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
              >
                What You Will <span>Receive</span>
              </h3>
              <div className="programe-block">
                <h4
                  data-aos="fade-zoom-in"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="630"
                >
                  Each <span className="pr-2">Programs</span>
                  Includes:
                </h4>
                <ul>
                  <li
                    data-aos="fade-zoom-in"
                    data-aos-offset="200"
                    data-aos-easing="ease-in-sine"
                    data-aos-duration="660"
                  >
                    <img src="/images/check-arrow-img.svg" alt="img" />
                    Corrective exercises & stretches for your BODY TYPE
                  </li>
                  <li
                    data-aos="fade-zoom-in"
                    data-aos-offset="200"
                    data-aos-easing="ease-in-sine"
                    data-aos-duration="690"
                  >
                    <img src="/images/check-arrow-img.svg" alt="img" />
                    Trigger Point & Muscle Library
                  </li>
                </ul>
              </div>
              <div className="programe-block">
                <h4
                  data-aos="fade-zoom-in"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="720"
                >
                  Educational <span>Videos</span>
                </h4>
                <ul>
                  <li
                    data-aos="fade-zoom-in"
                    data-aos-offset="200"
                    data-aos-easing="ease-in-sine"
                    data-aos-duration="750"
                  >
                    <img src="/images/check-arrow-img.svg" alt="img" />
                    Learn about muscle imbalances and prevention
                  </li>
                  <li
                    data-aos="fade-zoom-in"
                    data-aos-offset="200"
                    data-aos-easing="ease-in-sine"
                    data-aos-duration="780"
                  >
                    <img src="/images/check-arrow-img.svg" alt="img" />
                    Tips on how to perform each exercise correctly
                  </li>
                  <li
                    data-aos="fade-zoom-in"
                    data-aos-offset="200"
                    data-aos-easing="ease-in-sine"
                    data-aos-duration="810"
                  >
                    <img src="/images/check-arrow-img.svg" alt="img" />
                    Common exercise mistakes
                  </li>
                  <li
                    data-aos="fade-zoom-in"
                    data-aos-offset="200"
                    data-aos-easing="ease-in-sine"
                    data-aos-duration="840"
                  >
                    <img src="/images/check-arrow-img.svg" alt="img" />
                    Exercises and stretches to avoid, for now
                  </li>
                  <li
                    data-aos="fade-zoom-in"
                    data-aos-offset="200"
                    data-aos-easing="ease-in-sine"
                    data-aos-duration="870"
                  >
                    <img src="/images/check-arrow-img.svg" alt="img" />
                    3D animated skeleton and muscle videos
                  </li>
                </ul>
              </div>
              <div
                className="learm-more-link"
                data-aos="fade-zoom-in"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="900"
              >
                <Button
                  onClick={() => navigate("/educational-video-details")}
                  className="common-btn education-learn-more"
                >
                  Learn More
                </Button>{" "}
              </div>
            </div>
            <div className="receive-block-inner-right video-duration-hide">
              <div
                className="receive-block-inner-right-top"
                data-aos="fade-zoom-in"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="650"
              >
                <img src="/images/computer-mobile-img.png" alt="img" />
              </div>
              <Slider
                {...sliderSettings}
                className="receive-block-inner-right-bottom"
              >
                {videos.map((video, index) => (
                  <div
                    key={index}
                    className="receive-block-inner-right-bottom-inner"
                    data-aos="fade-zoom-in"
                    data-aos-offset="200"
                    data-aos-easing="ease-in-sine"
                    data-aos-duration={video.duration}
                  >
                    <div className="receive-block-video">
                      <video
                        playsInline
                        autoPlay
                        muted
                        loop
                        preload="auto"
                        ref={(el) => (videoRefs.current[index] = el)}
                        className="video"
                        width="100%"
                        height="100%"
                      >
                        <source src={video.src} type="video/mp4" />
                      </video>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonial-block">
        <div className="testimonial-block-data">
          <div className="testimonial-width">
            <div
              className="testimonial-slider"
              data-aos="fade-zoom-in"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="730"
            >
              <Slider {...settingsAbout}>
                {typeFirstTestimonials.map((testimonial, index) => (
                  <div>
                    <div className="testimonial-block-inner">
                      <div className="testimonial-block-inner-left">
                        <div className="testimonial-content">
                          <h2>What Our Clients Are Saying</h2>
                          <p>{testimonial?.description}</p>
                          <h5>
                            {testimonial?.name}, {testimonial?.title}
                          </h5>
                        </div>
                      </div>
                      <div className="testimonial-block-inner-right">
                        <img src={testimonial?.image} alt="img" />
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
      <section
        className="testimonial-block-last"
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-easing="ease-in-sine"
        data-aos-duration="600"
      >
        <div className="common-container">
          <Slider {...settingsTestimonial}>
            {typeSecondTestimonials.map((testimonial, index) => (
              <div>
                <div className="testimonial-block-last-inner">
                  <div className="testimonial-block-box">
                    <div className="testimonial-block-box-inner">
                      <div className="testimonial-img">
                        <img src={testimonial?.image} alt="img" />
                      </div>
                      <p>“{testimonial?.description}”</p>
                      <h6>-{testimonial?.name}</h6>
                      <ul>
                        {[...Array(testimonial?.rating || 0)].map((_, i) => (
                          <li key={i}>
                            <img src="/images/star-rating-icon.png" alt="img" />
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
      <section className="goal-block">
        <div className="common-container">
          <div className="common-title-block">
            <h3
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="630"
            >
              Our End
              <span className="pl-2">Goal</span>
            </h3>
            <p
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="660"
            >
              Help as many people as possible continue to do the things they
              love to do!
            </p>
          </div>
          <div className="goal-block-img">
            <img
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="690"
              src="/images/athelet-img-block.png"
              alt="img"
            />
            <div
              className="goal-block-img"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="710"
            >
              <CustomVideoPlayer
                videoUrl="https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/New/Look+At+You+Now+Video+Com+COM.mp4"
                className={"video"}
                disableLazy={true}
              />
            </div>
          </div>
        </div>
      </section>
    </HomePage>
  );
};

export default Home1;
